import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '1',
  title: 'Sign Up',
  description: 'Create your account and complete the quick onboarding process.'
}, {
  number: '2',
  title: 'Customize',
  description: 'Set your business hours, customize greetings, and integrate your tools.'
}, {
  number: '3',
  title: 'Go Live',
  description: 'Activate WellAd and start receiving professionally handled calls immediately.'
}];
export function HowItWorks() {
  return <section id="how-it-works" className="py-16 md:py-24 lg:py-32 bg-white" data-id="element-149">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8" data-id="element-150">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 md:mb-20" data-id="element-151">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-3 md:mb-4" data-id="element-152">
            How It Works
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-2xl mx-auto px-4" data-id="element-153">
            Getting started with WillAdd is simple and takes just minutes
          </p>
        </motion.div>
        <div className="relative" data-id="element-154">
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-0.5 bg-gradient-to-r from-indigo-500 via-purple-500 to-sky-500 -translate-y-1/2" data-id="element-155" />
          <div className="grid md:grid-cols-3 gap-8 md:gap-12 relative" data-id="element-156">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} className="text-center relative" data-id="element-157">
                <motion.div whileHover={{
              scale: 1.1,
              rotate: 360
            }} transition={{
              duration: 0.5
            }} className="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-indigo-500 to-sky-500 rounded-full flex items-center justify-center mx-auto mb-4 md:mb-6 shadow-lg relative z-10" data-id="element-158">
                  <span className="text-2xl md:text-3xl font-bold text-white" data-id="element-159">
                    {step.number}
                  </span>
                </motion.div>
                <h3 className="text-xl md:text-2xl font-bold text-black mb-3 md:mb-4" data-id="element-160">
                  {step.title}
                </h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed px-2" data-id="element-161">
                  {step.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}